import React, { useState, useEffect } from 'react';
import { FaBars, FaTimes} from 'react-icons/fa';
import NavBar from './NavBar';
import { Link, useLocation } from 'react-router-dom';
import './IndiaFocus.css';
import imageChina from './assets/images/India-Page-third-image.jpg';
import abt_first from './assets/images/man-in-black-shirt-sits-behind-desk-with-computers-2102416-scaled.jpg';
import business from './assets/images/business-meeting.jpg';
import logo from './assets/images/favicon1.webp';
import logo1 from './assets/images/0040C0.png';
import last from './assets/images/India-Page-last-image-scaled.jpg';

const IndiaFocus = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
   useEffect(() => {
            document.title = "India Focus – Bay Capital Advisors";
            
            // Find and update the favicon
            let favicon = document.querySelector("link[rel~='icon']");
            if (!favicon) {
              favicon = document.createElement('link');
              favicon.rel = 'icon';
              document.head.appendChild(favicon);
            }
            favicon.href = logo; // Use your logo as favicon
            
            return () => {
              // Reset title when component unmounts if needed
              document.title = "Bay Capital Advisors";
            };
          }, []);
        
          const toggleMobileMenu = () => {
            setIsMobileMenuOpen(!isMobileMenuOpen);
          };
        
          const closeMobileMenu = () => {
            setIsMobileMenuOpen(false);
          };
  return (
    <div className="india-focus-page">
      <div className="mobile-menu-button" onClick={toggleMobileMenu}>
        {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
      </div>
      
      {/* Mobile Menu Dropdown */}
      {isMobileMenuOpen && (
        <div className="mobile-dropdown-overlay" onClick={closeMobileMenu}>
          <div className="mobile-dropdown" onClick={(e) => e.stopPropagation()}>
            <NavBar isMobile={true} closeMenu={closeMobileMenu} />
          </div>
        </div>
      )}
        <section class="hero4">
    
        <div class="blue-overlay"></div>
    
    <header class="header4">
    <NavBar />
  </header>
        <header className="india-focus-header">
        
          <h1>INDIA FOCUS</h1>
        
      </header>
      </section>
      <div className="india-content">
        <div className="text-column">
          <p>
          Over the last few years India has been the fastest growing market in the world averaging over 8% annual growth.  Coming into 2020 and beyond growth appears to be muted, but will recover somewhat in the coming years.
          </p>
          <p>
          In response to a fiscal and balance of payments crisis in 1991, India launched a programme of economic policy reforms. The programme, consisting of stabilization and structural adjustment measures, was put in place with a view to attain macroeconomic stability and higher rates of economic growth.
          </p>
          <div className="india-image">
            <img src={business} alt="China Focus" />
        </div>
        </div>

        <div className="text-column1">
          <p>
          Some rethinking on economic policy had begun in the early 1980s, by when the limitations of the earlier strategy based upon import substitution, public sector dominance and extensive government control over private sector activity had become evident, however, the policy response was limited only to liberalising particular aspects of the macroeconomic system.
          </p>
          <p>
          By contrast, the reforms in the late 1990s in the industrial, trade, and financial sectors, among others, were much wider and deeper. As a consequence, they have contributed more meaningfully in attaining higher rates of growth. India has gone through the first decade of her reform process. Hence, an assessment of what has been achieved so far and what remains on the reform agenda is in order.
          </p>
          <p>
          Four different governments were in office during the 1990s — the Congress government which initiated the reforms in 1991, the United Front coalition (1996-98) which continued the process, the BJP-led coalition which took office in March 1998 and then again the BJP-led National Democratic Alliance (NDA) in October 1999 till date. In short, it seems that India’s political system is more than ever in consensus about the basic direction of reforms.
          </p>
          
        </div>
      </div>

      <div className="concluding-section-div1">
        <section className="concluding-section1">
            <p style={{ marginBottom: '20px' }}>The new experience of successful coalition governments in India has been ideal for democratic governance, balancing divergent views and accommodating regional and sectoral interests more effectively. This has imparted some degree of stability and consistency in economic policymaking.
            </p>
            
            <p> In broad terms, we are firmly of the view that the current decade is going to be India’s decade of development and that the country is on its way to sustaining a period of high economic growth, say, 7-8 per cent per annum.
            </p>
        </section>
      </div>

      <div className="india-content1">
        <div className="text-column12">
          <p>
            Since India’s economic reforms were launched in 1991, the Indian economy has sustained an annual average growth rate of over 6 per cent. In 2003-04, GDP growth is expected to be around 7.5 per cent.
          </p>
          <p>
            India’s foreign exchange reserves have crossed $100 billion. The current account deficit turned into a surplus over the last four years. This was achieved through non-debt creating flows, so that India’s external debt has remained virtually static in nominal terms. The debt servicing and debt GDP ratios have fallen sharply. In fact, India is now repaying foreign debt ahead of schedule.
          </p>
        </div>

        <div className="text-column11">
        <div className="india-image1">
            <img src={abt_first} alt="China Focus" />
        </div>
          
        </div>
      </div>
      <div className="concluding-section-div2">
        <section className="concluding-section2">
            <p style={{ marginBottom: '20px' }}>India is becoming a production base and an export hub for diverse goods, from agricultural products to automobile components to high-end services. Indian firms are now part of global production chains — importing sub-assemblies, adding value to them and re-exporting them.  Indian companies have also embarked on a global buying spree of notable and well known global brands.
            </p>
            <p style={{ marginBottom: '20px' }}> Taking advantage of its pool of high-quality scientific talent, international corporations have established large R&D centres in India. All these strengths have resulted in a greater integration of the Indian economy with the world economy. Trade has risen from 21 per cent to 33 per cent of India’s GDP in a decade.
            </p>
            <p> India’s strong economic growth is succeeding in bringing people out of poverty, nevertheless the country still has a long way to go before it can eradicate poverty.
            </p>
        </section>
      </div>
      <div className="india-content11">
        <div className="text-column121">
          <p>
          However, it increasingly appears that the ingredients of rapid poverty eradication are falling into place. From roads to telecommunication, the country is seeing the beginning of a qualitative change and growth in infrastructure.
          </p>
          <p>
          Since April 2003, India has been adding nearly 2 million mobile connections every month. The enormous successes of India’s IT professionals and the new successes of IT-enabled services have been made possible by the fact that the data and voice carrying capacity in India today has been enhanced dramatically.
          </p>
          <p>
          India is meeting almost 70 per cent demand of the worldwide business process outsourcing (BPO).
          </p>
          <p>
          Operating through satellite links, Indian programmers are providing IT support to US and European firms in areas ranging from software development and maintenance, back-office operations, data transcription and transmission, telemarketing, and other related areas.
          </p>
        </div>

        <div className="text-column111">
        <p>
        In the last year or so, US and European firms in the health, insurance and banking sectors, to mention a few, are also increasingly resorting to the BPO route to cut their costs. In India, unlike in China and the Philippines, BPO is sought after not just on cost considerations, but for better quality as well. As far as BPO in India is concerned, firms go there for cost, and stay there for quality.
          </p>
          <div className="india-image11-container">
            <div className="image-overlay-wrapper">
              <img src={imageChina} alt="China Focus" />
            </div>
          </div>

        </div>

    </div>

    <div className="india-content111">
    <div className="text-column1211">
      <div className="india-image111">
        <div className="image-overlay-container">
          <img src={last} alt="China Focus" />
        </div>
      </div>
    </div>

        <div className="text-column1111">
        <p>
        The federal government has launched an ambitious project for a highways network, which is linking the country’s major metropolitan centres and is providing improved connectivity to India’s rural areas. These roads can already be seen transforming the Indian economy.
          </p>
          <p>
          Similarly, in terms of federal support for primary schools under the `Sarva Siksha Abhiyan’ (literacy for all) scheme, which was put in place in November 2000 to attain universal primary literacy by the year 2010, large sums of federal money is being invested in, among other things, constructing new school buildings, upgrading facilities in existing schools, recruiting and training teachers and revising syllabi.
          </p>

        </div>

    </div>



    <div className="concluding-section-div3">
        <section className="concluding-section3">
        <h2 className="outlook-title">Outlook</h2>
        <ul className="outlook-list">
          <li>More than three decades since opening the economy, India has produced new dynamism, most dramatically in the information technology sector, but in others as well.</li>
          <li>The new technologies (especially information technology, pharmaceuticals, manufacturing, and consumer products) give new opportunities for economic and social development.</li>
          <li>The reforms implemented so far have helped India attain 6-plus percent growth; however, should India be able to implement these remaining reforms and re-orient governmental spending away from inessential expenditures and towards high-priority areas of health, education, and infrastructure development, then it is very likely that it would attain and sustain even higher rates of economic growth.</li>
          <li>If India does grow consistently at around 7-8 percent per year, this is likely to push up its domestic savings in the next few decades.</li>
          <li>Stronger growth should attract more foreign savings, especially foreign direct investment, and thus raise the overall investment rate.</li>
        </ul>
        </section>
      </div>


      {/* Footer Section */}
     <div className="footer-section">
        <nav>
          <a href="/CoreValues">Core Values</a>
          <a href="/Resources">Resources</a>
          <a href="/ContactUs">Contact Us</a>
        </nav>
        <div className="footer-logo">
                <Link to="/"> {/* Add this Link wrapper */}
                  <img src={logo1} alt="Bay Capital Advisors Logo" className="logo" />
                </Link>
                </div>
        <nav>
          <a href="/PrivacyPolicy">Privacy Policy</a>
          <a href="/TermsOfService">Terms of Service</a>
        </nav>
      </div>
    </div>
  );
};

export default IndiaFocus;